import React from 'react';
import { FieldArray, FieldArrayRenderProps, Formik, FormikProps, Form } from 'formik';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { SearchProps } from '../../models/arc-epi-props';
import { Officer } from './institution-officers-models';
import { FormField } from '../../../../global/components/form-element/form-field';
import { FormWrapper } from '../../../../global/components/form-wrapper';

interface Props {
    officerToRemove: Officer;
    settings: SearchProps;
    cancelAction: any;
    confirmAction: any;
}
export function OfficerRemoveConfirmation(props: Props) {
    const { officerToRemove, settings, cancelAction, confirmAction } = props;

    const onChange = (e, fieldArrayProps: FieldArrayRenderProps, formProps) => {
        const values = formProps.values.roles;
        const { value } = e.target;
        if (e.target.checked) {
            fieldArrayProps.push(value);
        } else {
            fieldArrayProps.remove(values.indexOf(value));
        }

    };
    const keys = Object.keys(officerToRemove?.roles);
    const roleToRemove = keys?.filter(k => !officerToRemove?.roles[k]?.implicit)?.map(roleName => officerToRemove?.roles[roleName]);

    return (
        <>
            <ContentSpacer>
                <div className='rich-text'>
                    {settings?.removeOfficerModalTitle && <h3>{settings?.removeOfficerModalTitle}</h3>}
                    {settings.removeOfficerModalDescription && <p>{settings.removeOfficerModalDescription}</p>}
                </div>
            </ContentSpacer>
            <Formik
                initialValues={{ roles: [] }}
                onSubmit={(values) => confirmAction(values?.roles)}
                enableReinitialize
            >
                {(formProps: FormikProps<any>) => (
                    <Form>
                        <FormWrapper
                            formikProps={formProps}
                            submitText={settings.confirmRemoveOfficerText}
                            cancelText={settings.cancelText}
                            onCancel={cancelAction}
                            preventButtonDisableValidation
                            submitDisabled={formProps?.values?.roles?.length === 0}
                        >
                            <ContentSpacer>
                                <FieldArray
                                    name='roles'
                                    render={(fieldArrayProps) => (
                                        <>

                                            <h5 className='modal-content-subtitle'>{settings?.removeAccessLabel}</h5>
                                            {
                                                roleToRemove?.map(role =>
                                                    <FormField
                                                        id={role?.role_assignment_id}
                                                        key={role?.role_assignment_id}
                                                        name='roles'
                                                        label={settings?.officersRoleMapping?.find(roleNameMap => roleNameMap?.key === role?.role_name)?.value}
                                                        component='checkBox'
                                                        value={role?.role_name}
                                                        checked={formProps.values?.roles.includes(role?.role_name)}
                                                        checkBoxGroup
                                                        onChange={(e) => onChange(e, fieldArrayProps, formProps)}
                                                    />,
                                                )
                                            }

                                        </>
                                    )}
                                />
                            </ContentSpacer>

                        </FormWrapper>
                    </Form>
                )}
            </Formik >
        </>
    );
}
